module.exports = __webpack_public_path__ + "static/media/idleDesktopImg.cd710a98.png";